import React from "react";

function backingParts(selection) {
  return String(selection || "")
    .split(" · ")
    .map((part) => part.trim())
    .filter(Boolean);
}

export default function P2PLedgerBacking({ selection }) {
  if (!selection) return null;

  const parts = backingParts(selection);

  return (
    <div className="ap2p-row-backing" title={selection}>
      <span className="ap2p-row-backing-key">Backing</span>
      {parts.length > 1 ? (
        <span className="ap2p-row-backing-parts">
          {parts.map((part) => (
            <span key={part} className="ap2p-row-backing-part">
              {part}
            </span>
          ))}
        </span>
      ) : (
        <span className="ap2p-row-backing-val">{selection}</span>
      )}
    </div>
  );
}
